<template>
  <div :class="$style.frameParent">
    <div :class="$style.frameGroup">
      <h2>{{ title }}</h2>
      <div :class="$style.frameContainer">
        <div :class="$style.formGroup">
          <div>Current valid certifications held?</div>
          <HiloSelect
            :theme="'grey'"
            v-model="form.validCertifications"
            :options="[
              { id: true, name: 'Yes' },
              { id: false, name: 'No' },
            ]"
            :placeholder="'Select all that apply...'"
            :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
          />
        </div>

        <div :class="$style.formGroup">
          <div>
            How many years of experience do you have in aircraft maintenance?
          </div>
          <input
            type="text"
            v-model="form.experience"
            placeholder="Type your answer..."
          />
        </div>

        <div :class="$style.formGroup">
          <div>
            What types of aircraft have you worked on? (Check all that apply):
          </div>
          <input
            type="text"
            v-model="form.aircraft"
            placeholder="Type your answer..."
          />
        </div>

        <div :class="$style.formGroup">
          <div>What are your areas of expertise? (Check all that apply):</div>
          <HiloSelect
            :theme="'grey'"
            v-model="form.areaOfExpertise"
            :options="[
              { id: true, name: 'Yes' },
              { id: false, name: 'No' },
            ]"
            :placeholder="'Select all that apply...'"
            :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
          />
        </div>

        <div :class="$style.formGroup">
          <div>
            Are you authorized to work on the following aircraft types? (Check
            all that apply):
          </div>
          <HiloSelect
            :theme="'grey'"
            v-model="form.authorization"
            :options="[
              { id: true, name: 'Yes' },
              { id: false, name: 'No' },
            ]"
            :placeholder="'Choose one...'"
            :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
          />
        </div>

        <div :class="$style.formGroup">
          <div>
            Have you ever been involved in a maintenance-related incident
            requiring FAA reporting? (Optional)
          </div>
          <HiloSelect
            :theme="'grey'"
            v-model="form.incident"
            :options="[
              { id: true, name: 'Yes' },
              { id: false, name: 'No' },
            ]"
            :placeholder="'Choose one...'"
            :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
          />
        </div>

        <div :class="$style.formGroup">
          <div>How do you handle challenges or setbacks?</div>
          <input
            type="text"
            v-model="form.handleChallenges"
            placeholder="Type your answer..."
          />
        </div>

        <div :class="$style.formGroup">
          <div>What is the highest level of education you have achieved?</div>
          <HiloSelect
            :theme="'grey'"
            v-model="form.educationLevelId"
            :options="educationLevelsList"
            :placeholder="'Choose one...'"
            :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
          />
        </div>

        <div :class="$style.formGroup">
          <div>Will you be part time or full time?</div>
          <HiloSelect
            :theme="'grey'"
            v-model="form.fullOrPartTimeId"
            :options="fullOrPartTimeList"
            :placeholder="'Choose one...'"
            :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
          />
        </div>

        <div :class="$style.spaceBetween">
          <div :class="$style.formGroup">
            <div>Upload a copy of your resume.</div>
          </div>
          <div :class="$style.formGroup">
            <button :class="$style.uploadBtn">Upload</button>
          </div>
        </div>

        <div :class="$style.spaceBetween">
          <div :class="$style.formGroup">
            <div>Upload a copy of your cover letter.</div>
          </div>
          <div :class="$style.formGroup">
            <button :class="$style.uploadBtn">Upload</button>
          </div>
        </div>

        <div :class="$style.spaceBetween">
          <div :class="$style.formGroup">
            <div>Upload copies of your certifications.</div>
          </div>
          <div :class="$style.formGroup">
            <button :class="$style.uploadBtn">Upload</button>
          </div>
        </div>

        <div :class="$style.formGroup">
          <div>
            Are you currently employed at a flight school or aviation company?
          </div>
          <HiloSelect
            :theme="'grey'"
            v-model="form.employed"
            :options="[
              { id: true, name: 'Yes' },
              { id: false, name: 'No' },
            ]"
            :placeholder="'Choose one...'"
            :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
          />
        </div>

        <div :class="$style.formGroup">
          <div>Employer Name</div>
          <input
            type="text"
            v-model="form.employerName"
            placeholder="Employer..."
          />
        </div>

        <div :class="$style.flexGroup" :style="$global.dynamicCols(2)">
          <div :class="$style.formGroup">
            <div>Email</div>
            <input
              type="email"
              v-model="form.employerEmail"
              placeholder="Email..."
            />
          </div>
          <div :class="$style.formGroup">
            <div>Phone</div>
            <input
              type="text"
              v-model="form.employerPhone"
              placeholder="Phone number..."
            />
          </div>
        </div>

        <div :class="$style.formGroup">
          <p>Provide two references flight schools can contact:</p>
        </div>

        <div
          :class="$style.flexGroup"
          v-for="(reference, index) in form.references"
          :key="index"
        >
          <div :class="$style.formGroup">
            <div>Reference {{ index + 1 }}:</div>
            <input v-model="reference.name" type="text" placeholder="Name..." />
          </div>
          <div :class="$style.flexGroup" :style="$global.dynamicCols(2)">
            <div :class="$style.formGroup">
              <input
                v-model="reference.phone"
                type="text"
                placeholder="Phone Number..."
              />
            </div>
            <div :class="$style.formGroup">
              <input
                v-model="reference.email"
                type="text"
                placeholder="Email..."
              />
            </div>
          </div>
          <div :class="$style.formGroup">
            <HiloSelect
              :id="'relationshipList' + index"
              :theme="'grey'"
              v-model="reference.relationshipId"
              :options="relationshipsList"
              :placeholder="'Relationship...'"
              :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
            />
          </div>
        </div>

        <div :class="$style.buttonContainer">
          <div
            :class="$style.nextButton"
            @click="$emit('onNext', { aboutYou: form })"
          >
            <b :class="$style.name">Next</b>
          </div>
          <div :class="$style.backButton" @click="$emit('onPrev')">
            <b :class="$style.name">Back</b>
          </div>
        </div>
      </div>
      <div :class="$style.frameChild4" />
    </div>
    <div :class="$style.frameChild5" />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import HiloSelect from "@/components/HiloComponents/HiloSelect.vue";
import AboutYouAPIService from "@/servicehandlers/AboutYouAPIService";
const aboutYouAPIService = new AboutYouAPIService();
export default defineComponent({
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  components: {
    HiloSelect,
  },
  data() {
    return {
      form: {
        validCertifications: "",
        experience: "",
        aircraft: "",
        areaOfExpertise: "",
        authorization: "",
        incident: "",
        handleChallenges: "",
        educationLevelId: "",
        employed: "",
        employerEmail: "",
        employerName: "",
        employerPhone: "",
        fullOrPartTimeId: "",
        references: [
          { name: "", phone: "", email: "", relationshipId: "" },
          { name: "", phone: "", email: "", relationshipId: "" },
        ],
      },
      relationshipsList: [],
      educationLevelsList: [],
      fullOrPartTimeList: [],
    };
  },
  mounted() {
    this.getAboutYouLists();
  },
  methods: {
    async getAboutYouLists() {
      try {
        this.educationLevelsList =
          await aboutYouAPIService.getEducationLevelsList();
        this.relationshipsList =
          await aboutYouAPIService.getRelationshipsList();
        this.relationshipsList = this.relationshipsList.filter(
          (relationship) => relationship.abtYouMaintenance,
        );
      } catch (error) {}
    },
  },
});
</script>

<style module scoped>
.buttonContainer {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.buttonContainer div {
  align-self: stretch;
  border-radius: 10px;
  height: 50px;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
  color: #fff;
  transition: 0.2s ease-in-out;
}

.buttonContainer div:hover {
  opacity: 0.8;
}

.nextButton {
  background-color: #3c78ff;
}

.backButton {
  background-color: #ccc;
}
.frameGroup {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.uploadBtn {
  width: fit-content;
  align-items: end;
}

.flexGroup {
  display: grid;
  gap: 10px;
}

.spaceBetween {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.formGroup {
  display: flex;
  flex-direction: column;
  gap: 5px;
  position: relative;
}

.formGroup p {
  font-size: 16px;
}

.frameContainer {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 25px;
}
</style>
